import { render, staticRenderFns } from "./costAnalysis.vue?vue&type=template&id=01ab5709&scoped=true"
import script from "./costAnalysis.vue?vue&type=script&lang=js"
export * from "./costAnalysis.vue?vue&type=script&lang=js"
import style0 from "./costAnalysis.vue?vue&type=style&index=0&id=01ab5709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab5709",
  null
  
)

export default component.exports